import { soFetch } from 'so-fetch';
import * as constants from './temp-connections-constants';

export function updateTempConnectionsProps(payload) {
  return { type: constants.UPDATE_TEMP_CONN_PROP, payload };
}

export function getTempConnections() {
  return soFetch('/proxy/temp-invitation', {
    actionType: constants.RECEIVE_ADD_CONNECTIONS,
    responseBinding: 'payload',
  });
}

export function sendTempConnections(connections) {
  return soFetch('/proxy/temp-invitation', {
    method: 'post',
    body: { invitations: connections },
    actionType: constants.SEND_TEMP_CONNECTIONS,
    responseBinding: 'payload',
  });
}

export function sendEmailToTempConnectionsStarting() {
  return { type: constants.SEND_EMAIL_TO_TEMP_CONNECTIONS_STARTING };
}

export function sendEmailToTempConnections(message) {
  return soFetch('/proxy/temp-invitation/send', {
    method: 'put',
    body: { message },
    actionType: constants.SEND_EMAIL_TO_TEMP_CONNECTIONS,
    responseBinding: 'payload',
  });
}

export function deleteTempConnections() {
  return soFetch('/proxy/temp-invitation/delete', {
    method: 'delete',
    actionType: constants.DELETED_TEMP_CONNECTIONS,
    responseBinding: 'connections',
  });
}

export function cancelCSVHeaderSelection() {
  return {
    type: constants.CANCEL_CSV_HEADER_SELECTION,
  };
}

export function convertFromCSV(fileContents) {
  return {
    type: constants.CONVERT_FROM_CSV,
    payload: fileContents,
  };
}

export function cancelCurrentCSVSelection() {
  return {
    type: constants.CANCELED_CSV_SELECTION,
  };
}


export function acceptCurrentCSVSelection() {
  return {
    type: constants.ACCEPTED_CSV_SELECTION,
  };
}


export function isPersistedFromServer() {
  return {
    type: constants.IS_PERSISTED_FROM_SERVER,
  };
}


export function addAnotherConnection() {
  return {
    type: constants.NEW_ADD_CONNECTIONS,
  };
}


export function removeInvitation(mapKey) {
  return {
    type: constants.REMOVE_ADD_INVITATION,
    payload: mapKey,
  };
}

export function changeCollectionItemValue(mapKey, valueKey, value) {
  return {
    type: constants.CHANGE_NEW_CONNECTION_VALUE,
    payload: {
      mapKey,
      valueKey,
      value,
    },
  };
}

export function changeEmailValue(value) {
  return {
    type: constants.CHANGE_EMAIL_VALUE,
    payload: value,
  };
}



// WEBPACK FOOTER //
// ./src/app/stores/temp-connections/temp-connections-actions.js